// @ts-nocheck
import { Box, Text, Center, Flex, HStack, Grid } from "@chakra-ui/react";
import { roundUp } from "utils/helpers"
import PuffLoader from "react-spinners/PuffLoader";
import { color, textStyle } from "theme/names";

export function Account({ tweetStats = [], accountStats = [], isLoading=false }) {
  const followers = accountStats?.length ? accountStats[0].followerCount : 0;
  const followersChange =
    accountStats[accountStats.length - 1]?.followers_count -
      accountStats[0]?.followers_count || 0;
  const followerChangePercent =
    (followersChange * 100) / accountStats[0]?.followers_count;
  const sign = followersChange > 0 ? "+" : "";

  let impressions = 0,
    profileVisits = 0,
    engagement = 0;
  
  if (tweetStats?.length > 0) {
    tweetStats.forEach((tweet) => {
      if (tweet.numViews) impressions += tweet.numViews;
      engagement += (tweet.numLikes ?? 0) + (tweet.totalShares ?? 0) + (tweet.numComments ?? 0);
    });
  }

  return (
    <Box>
      {
        isLoading ? (
            <Center pt={10} h="200px">
              <PuffLoader
                color={"#0A66C2"} 
                loading={isLoading}
                cssOverride={{display: "block", margin: "0 auto", borderColor: "red"}}
                size={50}
              />
            </Center>
          ) : (
            <Grid
              // alignItems={{ base: "center", md: "space-between" }}
              templateColumns={{ xl: "repeat(4, 1fr)", lg: "repeat(2, 1fr)", sm: "repeat(1, 1fr)" }}
              columnGap={{ lg: 10, md: 0 }}
              rowGap={0}
              fontWeight="bold"
              paddingY="12"
            >
              {/* <CustomBox>
                <Text color="red" fontSize="lg">
                  7
                </Text>
                <Text>DAYS STREAK</Text>
              </CustomBox> */}
              {/* <CustomBox title="FOLLOWERS" value={sign + roundUp(followersChange)} diff={sign + followerChangePercent.toFixed(1) + "%"} />
              <CustomBox title="PROFILE VISITS" value={roundUp(profileVisits)} />
              <CustomBox title="TOTAL ENGAGEMENT" value={roundUp(engagement)} />
              <CustomBox title="IMPRESSIONS" value={roundUp(impressions)} /> */}
              <CustomBox title="FOLLOWERS" value={roundUp(followers)} diff={sign + roundUp(followersChange)} />
              <CustomBox title="ENGAGEMENT" value={roundUp(engagement)} />
              <CustomBox title="VIEWS" value={roundUp(impressions)} />
            </Grid>
          )
      }
    </Box>
  );
}

export function CustomBox({ title, value, diff=undefined, children=undefined, ...rest }) {
  return (
    <Box
      // boxShadow="rgb(0 0 0 / 8%) 0px 5px 10px, rgb(0 0 0 / 20%) 0px 2px 20px"
      paddingX="5"
      width="40"
      height="28"
      borderRadius="md"
      paddingTop="3"
      // marginX="5"
      // marginY="2"
      margin="auto"
      display="flex"
      flexDir="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      {...rest}
      mb={{ base: diff && !diff.includes("NaN") ? 5 : 0, md: 0 }}
    >
      <Text
        textStyle={textStyle["body.medium.light"]}
        fontSize="xs"
        // color="gray.400"
        w="150px"
      >
        {title}
      </Text>
      <Text
        textStyle={textStyle["body.bold.standard"]}
        color={color["success.lightMode.400"]}
        fontSize="4xl"
      >
        {value}
      </Text>
      {/* {
        diff && !diff.includes("NaN") && (
          <Text fontSize="xs" color="gray" mt="1" mb="4">
            {diff}
          </Text>
        )
      } */}
    </Box>
  );
}
